import { createFileRoute, lazyRouteComponent, redirect } from '@tanstack/react-router';

/** The trailing underscore on `history` opts out of nesting under `history.tsx`, giving the URL `/imports/history/$importId`. */
export const Route = createFileRoute('/_authenticated/imports/history_/$importId')({
  beforeLoad: ({ context }): void => {
    if (context.permissions.isReady && !context.permissions.hasPermission('orders:write')) {
      throw redirect({ to: '/' });
    }
  },
  component: lazyRouteComponent(() => import('&/features/imports/pages/import-report-page')),
});
